import { ShieldCheck, TrendingUp, TriangleAlert } from "lucide-react";

// Sample Deal Feed — mock data seed for the SCROLL viewport (Section 2). No backend
// endpoint exists for the reseller feed yet; this is the same "PLACEHOLDER, clearly
// labeled" pattern used for the Daily Deck in Section 1. Real feed source is a future
// section's job.
const _RAW_DEALS = [
  {
    id: "item_101", title: "Sony WH-1000XM5 Headphones", price: 280.0, msrp: 399.0, manufacturer: "Sony",
    reseller: "Walmart US", verdict: "VERIFIED_LEGIT", likes: 24, dislikes: 2,
    likedByMe: false, dislikedByMe: false, isHearted: false,
    comments: [{ id: "c1", user: "Tyler", text: "Got these last week, super legit deal!" }],
    outboundUrl: "https://www.walmart.com/ip/12345",
    image: "https://images.unsplash.com/photo-1641048930621-ab5d225ae5b0?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_102", title: "iPhone 16 Pro 256GB — Unlocked", price: 1099.0, msrp: 999.0, manufacturer: "Apple",
    reseller: "Unknown Reseller", verdict: "OVERPRICED", likes: 5, dislikes: 12,
    likedByMe: false, dislikedByMe: false, isHearted: false, comments: [],
    outboundUrl: "https://example.com/iphone",
    image: "https://images.unsplash.com/photo-1592750475338-74b7b21085ab?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_103", title: "Nintendo Switch OLED — White", price: 349.99, msrp: 349.99, manufacturer: "Nintendo",
    reseller: "Target US", verdict: "VERIFIED_LEGIT", likes: 41, dislikes: 1,
    likedByMe: false, dislikedByMe: false, isHearted: false,
    comments: [{ id: "c2", user: "Maya", text: "Price matches in-store, solid." }],
    outboundUrl: "https://www.target.com/p/12345",
    image: "https://images.unsplash.com/photo-1612036781124-847f8939b154?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_104", title: "PS5 Slim Digital Edition", price: 549.0, msrp: 449.99, manufacturer: "Sony",
    reseller: "reseller-deals-hub.net", verdict: "HIGH_RISK", likes: 2, dislikes: 31,
    likedByMe: false, dislikedByMe: false, isHearted: false,
    comments: [{ id: "c3", user: "Jordan", text: "Domain isn't a known retailer, be careful." }],
    outboundUrl: "https://reseller-deals-hub.net/ps5",
    image: "https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_105", title: "Dyson V15 Detect Cordless Vacuum", price: 479.99, msrp: 749.99, manufacturer: "Dyson",
    reseller: "Best Buy US", verdict: "VERIFIED_LEGIT", likes: 63, dislikes: 3,
    likedByMe: false, dislikedByMe: false, isHearted: false, comments: [],
    outboundUrl: "https://www.bestbuy.com/site/12345",
    image: "https://images.unsplash.com/photo-1722710070534-e31f0290d8de?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_106", title: "Samsung Galaxy Buds3 Pro", price: 229.99, msrp: 249.99, manufacturer: "Samsung",
    reseller: "Swappa US", verdict: "VERIFIED_LEGIT", likes: 18, dislikes: 0,
    likedByMe: false, dislikedByMe: false, isHearted: false,
    comments: [{ id: "c4", user: "Priya", text: "Swappa always verifies condition, trust it." }],
    outboundUrl: "https://swappa.com/listing/12345",
    image: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_107", title: "MacBook Air M3 13\" 256GB", price: 1399.0, msrp: 1099.0, manufacturer: "Apple",
    reseller: "deal-flash-outlet.co", verdict: "OVERPRICED", likes: 4, dislikes: 19,
    likedByMe: false, dislikedByMe: false, isHearted: false, comments: [],
    outboundUrl: "https://deal-flash-outlet.co/macbook",
    image: "https://images.unsplash.com/photo-1611186871348-b1ce696e52c9?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_108", title: "iPad 10th Gen 64GB Wi-Fi", price: 279.0, msrp: 349.0, manufacturer: "Apple",
    reseller: "Back Market US", verdict: "VERIFIED_LEGIT", likes: 29, dislikes: 1,
    likedByMe: false, dislikedByMe: false, isHearted: false,
    comments: [{ id: "c5", user: "Sam", text: "Back Market's warranty makes this a no-brainer." }],
    outboundUrl: "https://www.backmarket.com/listing/12345",
    image: "https://images.unsplash.com/photo-1662893170097-d6563d0093d3?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_109", title: "LEGO Star Wars Millennium Falcon", price: 169.99, msrp: 169.99, manufacturer: "LEGO",
    reseller: "Walmart US", verdict: "VERIFIED_LEGIT", likes: 12, dislikes: 0,
    likedByMe: false, dislikedByMe: false, isHearted: false, comments: [],
    outboundUrl: "https://www.walmart.com/ip/54321",
    image: "https://images.unsplash.com/photo-1587654780291-39c9404d746b?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_110", title: "GoPro HERO12 Black", price: 449.0, msrp: 399.99, manufacturer: "GoPro",
    reseller: "grab-it-cheap-now.biz", verdict: "HIGH_RISK", likes: 1, dislikes: 22,
    likedByMe: false, dislikedByMe: false, isHearted: false,
    comments: [{ id: "c6", user: "Alex", text: "Price is above MSRP and the site looks sketchy." }],
    outboundUrl: "https://grab-it-cheap-now.biz/gopro",
    image: "https://images.unsplash.com/photo-1685615359827-aa31d97578e7?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "item_111", title: "Bose QuietComfort Ultra Earbuds", price: 249.0, msrp: 299.0, manufacturer: "Bose",
    reseller: "Target US", verdict: "VERIFIED_LEGIT", likes: 33, dislikes: 2,
    likedByMe: false, dislikedByMe: false, isHearted: false, comments: [],
    outboundUrl: "https://www.target.com/p/54321",
    image: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?crop=entropy&cs=srgb&fm=jpg&q=85&sig=2",
  },
  {
    id: "item_112", title: "Ninja Creami Ice Cream Maker", price: 199.99, msrp: 169.99, manufacturer: "Ninja",
    reseller: "hot-deal-express.net", verdict: "OVERPRICED", likes: 6, dislikes: 9,
    likedByMe: false, dislikedByMe: false, isHearted: false, comments: [],
    outboundUrl: "https://hot-deal-express.net/ninja-creami",
    image: "https://images.unsplash.com/photo-1629385701021-fcd568a743e8?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

// Section 5 — synthesizes a ranked `sources[]` list (index 0 = the primary/cheapest
// listing above) per item, purely so tier-based "extra sources" masking has real data
// to gate. Alt sources are deterministically derived, not independently verified deals.
const _ALT_RESELLERS = ["eBay US", "Newegg", "B&H Photo", "Costco US", "GameStop", "Micro Center"];

function withSources(item, altCount = 3) {
  const sources = [{ reseller: item.reseller, price: item.price, outboundUrl: item.outboundUrl }];
  for (let i = 0; i < altCount; i++) {
    const bump = 1 + (i + 1) * 0.04; // each alt source priced a little higher than the last
    sources.push({
      reseller: _ALT_RESELLERS[(i + item.id.length) % _ALT_RESELLERS.length],
      price: Math.round(item.price * bump * 100) / 100,
      outboundUrl: item.outboundUrl,
    });
  }
  return { ...item, sources, fulfillment: "ONLINE_SHIPPING" };
}

export const SEED_DEALS = _RAW_DEALS.map((it) => withSources(it));

// Verdict badges — the single most important 0.3-second-clarity element on any card,
// so each one is a bold, high-contrast, glowing solid pill (not a soft tint) with a
// distinct icon, never an emoji (per brand icon convention).
export const TRUST_BADGES = {
  VERIFIED_LEGIT: { Icon: ShieldCheck, label: "VERIFIED LEGIT", className: "badge-legit border border-emerald-300 bg-emerald-500 text-white shadow-[0_0_0_1px_rgba(16,185,129,0.35),0_0_16px_-2px_rgba(16,185,129,0.85)]" },
  OVERPRICED: { Icon: TrendingUp, label: "OVERPRICED", className: "badge-overpriced border border-amber-300 bg-amber-500 text-slate-950 shadow-[0_0_0_1px_rgba(245,158,11,0.35),0_0_16px_-2px_rgba(245,158,11,0.75)]" },
  HIGH_RISK: { Icon: TriangleAlert, label: "HIGH RISK", className: "badge-high-risk border border-rose-300 bg-rose-600 text-white shadow-[0_0_0_1px_rgba(225,29,72,0.35),0_0_16px_-2px_rgba(225,29,72,0.85)]" },
};

export function getTrustBadge(verdict) {
  return TRUST_BADGES[verdict] || TRUST_BADGES.HIGH_RISK;
}

// OEM vs. Reseller transparency (Section: PDP flow) — Discover's backend results have
// no dedicated manufacturer field, so this is a best-effort brand guess from the title
// for THOSE only; Scroll/Daily Deck cards already carry an explicit `manufacturer`.
const _KNOWN_BRANDS = ["Sony", "Apple", "iPhone", "iPad", "MacBook", "Samsung", "Nintendo", "Dyson", "Bose", "LEGO", "GoPro", "Ninja", "Microsoft", "Google", "Nike", "Adidas", "Bissell", "Shark", "KitchenAid", "Keurig", "Instant Pot", "PlayStation", "PS5", "Xbox"];
const _BRAND_ALIASES = { iPhone: "Apple", iPad: "Apple", MacBook: "Apple", PS5: "Sony", PlayStation: "Sony" };

export function guessManufacturer(title = "") {
  const hit = _KNOWN_BRANDS.find((b) => title.toLowerCase().includes(b.toLowerCase()));
  if (!hit) return (title.trim().split(" ")[0] || "Manufacturer");
  return _BRAND_ALIASES[hit] || hit;
}
